import axios from 'axios';
import { API_HOST } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';

export const getAddressLookup = async (search_term, mode = 'usps') => {
  // const apiURL = API_HOST + ('/locations/search/' + mode + '?search_term=' + search_term);
  console.info('[getAddressLookup] search_term: ', search_term);
  const apiURL = API_HOST + ('/location/' + mode + '_search/?street=' + search_term);
  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        'x-user-id': userID,
      },
    });
    return Array.isArray(data.suggestions) ? data.suggestions : []; // Ensure data is an array
  } catch (error) {
    console.error(error);
    return []; // Return an empty array on error
  }
};

export const postValidateAddress = async (options, mode = 'usps') => {
  // const apiURL = API_HOST + ('/locations/validation/' + mode);
  const apiURL = API_HOST + ('/location/' + mode + '_validation');
  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.post(
      apiURL,
      {
        ...options,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'x-user-id': userID,
        },
      },
    );
    return data;
  } catch (error) {
    console.error(error);
  }
};
